import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white/5 backdrop-blur-sm rounded-xl shadow-xl border border-zinc-800/40 p-6 md:p-8" }
const _hoisted_2 = { class: "space-y-3 grid grid-cols-4 gap-6" }

import { Trophy } from 'lucide-vue-next';
  import AwardCard from './AwardCard.vue';
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'AwardsContainer',
  props: {
    awards: {}
  },
  setup(__props: any) {

  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex justify-between items-center mb-6" }, [
      _createElementVNode("div", { class: "flex items-center" }, [
        _createElementVNode("h3", { class: "text-2xl font-bold text-white" }, "Lista de prêmios")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.awards, (award) => {
        return (_openBlock(), _createBlock(AwardCard, {
          key: award.id,
          award: award
        }, null, 8, ["award"]))
      }), 128))
    ])
  ]))
}
}

})